import React from 'react';
import "./secundary_button.css";
import { scrollToSectionUtils } from '../../../utils/scroll_to_section_ultils.jsx';

const SecundaryButton = ({ title, style_border, style_font_size, borderRadius, icon, font_color, className }) => {
    const handleClick = () => {
        scrollToSectionUtils('contato');
    };

    const useCssForColor = className && className.includes('get_in_touch_cta');
    const titleStyle = useCssForColor ? {} : { fontSize: style_font_size, color: font_color };

    return (
        <div
            className={`secundary_button ${className || ''}`.trim()}
            style={{ border: style_border, borderRadius: borderRadius }}
            onClick={handleClick}
        >
            <div className="title">
                <p style={titleStyle}>{title}</p>
            </div>

            <div className="icon">
                {icon}
            </div>

        </div>


    )
}

export default SecundaryButton

